import React from 'react';
import ReactDOM from 'react-dom';
import App from './componets/App/App';

ReactDOM.render(<App />, document.getElementById('root'));
